const state = {
  parcs: [],
  searchParams: {
    regionInsee: null,
    departementInsee: null,
    communeInsee: null,
    statutSaisieId: null,
    statutAdministratifId: null,
    statutParcId: null,
    etatParcId: null,
    numeroICPE: null
  },
  reloadParcsAndSearchParams: false
};

const mutations = {
  SET_PARCS(state, parcs) {
    state.parcs = parcs;
  },
  SET_REGION_INSEE(state, regionInsee) {
    state.searchParams.regionInsee = regionInsee;
  },
  SET_DEPARTEMENT_INSEE(state, departementInsee) {
    state.searchParams.departementInsee = departementInsee;
  },
  SET_COMMUNE_INSEE(state, communeInsee) {
    state.searchParams.communeInsee = communeInsee;
  },
  SET_STATUT_SAISIE_ID(state, statutSaisieId) {
    state.searchParams.statutSaisieId = statutSaisieId;
  },
  SET_STATUT_ADMINISTRATIF_ID(state, statutAdministratifId) {
    state.searchParams.statutAdministratifId = statutAdministratifId;
  },
  SET_STATUT_PARC_ID(state, statutParcId) {
    state.searchParams.statutParcId = statutParcId;
  },
  SET_ETAT_PARC_ID(state, etatParcId) {
    state.searchParams.etatParcId = etatParcId;
  },
  SET_NUMERO_ICPE(state, numeroICPE) {
    state.searchParams.numeroICPE = numeroICPE;
  },
  SET_RELOAD_PARCS_AND_SEARCH_PARAMS(state, reloadParcsAndSearchParams) {
    state.reloadParcsAndSearchParams = reloadParcsAndSearchParams;
  }
};

const actions = {
  saveParcs({ commit }, parcs) {
    commit("SET_PARCS", parcs);
  },
  saveSearchParams({ commit }, searchParams) {
    commit(
      "SET_REGION_INSEE",
      searchParams.regionInsee ? searchParams.regionInsee : null
    );
    commit(
      "SET_DEPARTEMENT_INSEE",
      searchParams.departementInsee ? searchParams.departementInsee : null
    );
    commit(
      "SET_COMMUNE_INSEE",
      searchParams.communeInsee ? searchParams.communeInsee : null
    );
    commit(
      "SET_STATUT_SAISIE_ID",
      searchParams.statutSaisieId ? searchParams.statutSaisieId : null
    );
    commit(
      "SET_STATUT_ADMINISTRATIF_ID",
      searchParams.statutAdministratifId
        ? searchParams.statutAdministratifId
        : null
    );
    commit(
      "SET_STATUT_PARC_ID",
      searchParams.statutParcId ? searchParams.statutParcId : null
    );
    commit(
      "SET_ETAT_PARC_ID",
      searchParams.etatParcId ? searchParams.etatParcId : null
    );
    commit(
      "SET_NUMERO_ICPE",
      searchParams.numeroICPE ? searchParams.numeroICPE : null
    );
  },
  resetSearchParams({ commit }) {
    commit("SET_REGION_INSEE", null);
    commit("SET_DEPARTEMENT_INSEE", null);
    commit("SET_COMMUNE_INSEE", null);
    commit("SET_STATUT_SAISIE_ID", null);
    commit("SET_STATUT_ADMINISTRATIF_ID", null);
    commit("SET_STATUT_PARC_ID", null);
    commit("SET_ETAT_PARC_ID", null);
    commit("SET_NUMERO_ICPE", null);
  },
  reloadParcsAndSearchParams({ commit }) {
    commit("SET_RELOAD_PARCS_AND_SEARCH_PARAMS", true);
  },
  parcsAndSearchParamsReloaded({ commit }) {
    commit("SET_RELOAD_PARCS_AND_SEARCH_PARAMS", false);
  }
};

const getters = {
  parcs(state) {
    return state.parcs;
  },
  searchParams(state) {
    return state.searchParams;
  },
  isParcs(state) {
    return state.parcs.length > 0;
  },
  isEmptySearch(state) {
    return (
      (state.searchParams.regionInsee != null ||
        state.searchParams.statutSaisieId != null ||
        state.searchParams.statutAdministratifId != null ||
        state.searchParams.statutParcId != null ||
        state.searchParams.etatParcId != null ||
        state.searchParams.numeroICPE != null) &&
      state.parcs.length == 0
    );
  },
  hasSearched(state) {
    return (
      state.searchParams.regionInsee != null ||
      state.searchParams.statutSaisieId != null ||
      state.searchParams.statutAdministratifId != null ||
      state.searchParams.statutParcId != null ||
      state.searchParams.etatParcId != null ||
      state.searchParams.numeroICPE != null
    );
  },
  reloadParcsAndSearchParams(state) {
    return state.reloadParcsAndSearchParams;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
